import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { ApiBaseService } from './api-base.service';
import { SharedService } from './shared.service';

import { Country, UploadPurpose } from '@models/Enums';

/**
 * Datos que el cliente declara para pedir permiso de subida. La carpeta destino no
 * viaja: la resuelve el backend a partir del propósito y del token.
 */
export interface PresignedUploadRequest {
    purpose: UploadPurpose;
    fileName: string;
    contentType: string;
    sizeBytes: number;
    scope?: string;
}

/**
 * Permiso de subida emitido por el API. La URL solo acepta un PUT con exactamente
 * el mismo contentType y tamaño, y vence a los pocos minutos.
 */
export interface PresignedUploadResponse {
    uploadUrl: string;
    objectKey: string;
    publicUrl: string;
    contentType: string;
    sizeBytes: number;
    expiresAt: string;
}

@Injectable()
export class ApiUploadService extends ApiBaseService {

    constructor(public http: HttpClient, public sharedService: SharedService) {
        super(http, sharedService);
    }

    // POST: api/admin/filestorage/presign/v1
    /**
     * Pide al API una URL prefirmada para subir un archivo a S3.
     * @param request Propósito, nombre, tipo y tamaño del archivo.
     * @param country País del request, cuando no es el de la sesión.
     */
    getPresignedUpload(request: PresignedUploadRequest, country?: Country): Promise<PresignedUploadResponse> {

        return this.http.post(`${this.baseUrl}/api/admin/filestorage/presign/v1`, request, this.getHttpOptions(country))
            .toPromise().then(
                (result: any) => {

                    return result as PresignedUploadResponse;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al preparar la subida del archivo: ${errMsg}`));
                }
            );
    }

    // POST: api/admin/filestorage/object/delete/v1
    /**
     * Borra un archivo previamente subido. El API valida que pertenezca al usuario.
     * @param purpose Propósito con el que se subió el archivo.
     * @param objectKey Key devuelto por el presign.
     * @param country País del request, cuando no es el de la sesión.
     */
    deleteUpload(purpose: UploadPurpose, objectKey: string, country?: Country): Promise<void> {

        const body = { purpose, objectKey };

        return this.http.post(`${this.baseUrl}/api/admin/filestorage/object/delete/v1`, body, this.getHttpOptions(country))
            .toPromise().then(
                () => {

                    return;
                },
                (err: HttpErrorResponse) => {

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al borrar el archivo: ${errMsg}`));
                }
            );
    }
}
